<header class="{{brand()}}">
  <div class="container-fluid container-lg">
    <nav class="navbar navbar-expand-md">
      <a class="navbar-brand" (click)="redirectToHome()">
        <img src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEELONELX25/Logo-Electrolux.svg"
          class="logo-aeg" *ngIf="brand() === 'elx'">
        <img src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/logo_aeg.png"
          class="logo-aeg da-DK" *ngIf="isAegBrandingCulture() && brand() === 'aeg'">

        <img src="{{'local-reseller-logo' | translate}}" alt="" class="power-logo d-inline-block d-md-none ms-3">

      </a>
      <button class="navbar-toggler" type="button" (click)="isCollapsed.set(!isCollapsed())">
        <span class="navbar-toggler-icon">
          <img class="icon-menu" src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/menu.png"
            style="max-width:30px;" [ngClass]="isCollapsed() ? 'd-none' : 'show'"
            *ngIf="isAegBrandingCulture() && brand()=='aeg'">
          <img class="d-md-none icon-close"
            src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/close.png"
            [ngClass]="isCollapsed() ? '' : 'd-none'" *ngIf="isAegBrandingCulture() && brand()=='aeg'">

          <img class="icon-menu" src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/menu_dark.png"
            style="max-width:30px;" [ngClass]="isCollapsed() ? 'd-none' : 'show'"
            *ngIf="!isAegBrandingCulture() && brand()=='elx'">
          <img class="d-md-none icon-close"
            src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/close_dark.png"
            [ngClass]="isCollapsed() ? '' : 'd-none'" *ngIf="!isAegBrandingCulture() && brand()=='elx'">

          <img class="icon-menu" src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/menu_dark.png"
            style="max-width:30px;" [ngClass]="isCollapsed() ? 'd-none' : 'show'"
            *ngIf="isAegBrandingCulture() && brand()=='elx'">
          <img class="d-md-none icon-close"
            src="https://assets.qnordicsgames.com/image/upload/q_auto/v1/SWEAEGELX25/close_dark.png"
            [ngClass]="isCollapsed() ? '' : 'd-none'" *ngIf="isAegBrandingCulture() && brand()=='elx'">
        </span>
      </button>

      <div class="collapse navbar-collapse navbar-collapse" id="navbarSupportedContent"
        [ngClass]="isCollapsed() ? 'show' : 'notvisible'">
        <ul class="navbar-nav ms-auto mb-3 mb-md-0 {{getTranslateDefaultLang()}} {{brand()}}">

          <li class="nav-item" (click)="isCollapsed.set(!isCollapsed())" *ngIf="!isHomePage()">
            <a [routerLink]="currentLang() ? ['/', currentLang()] : ['/']" [routerLinkActive]="'is-active'"
              [routerLinkActiveOptions]="{exact: true}" class="nav-link">
              {{'link-home' | translate}}
            </a>
          </li>

          <!-- <li class="nav-item" (click)="isCollapsed.set(!isCollapsed())">
            <a [routerLink]="'/winners'" [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}" class="nav-link">

              {{'link-winners' | translate}}
            </a>
          </li> -->
          <li class="nav-item" (click)="isCollapsed.set(!isCollapsed())">
            <a href="#" data-bs-target="#products" data-bs-toggle="modal" [routerLinkActive]="'is-active'"
              class="nav-link">
              {{'link-products' | translate}}
            </a>
          </li>
          <li class="nav-item" (click)="isCollapsed.set(!isCollapsed())">
            <a href="#" data-bs-target="#faq" data-bs-toggle="modal" [routerLinkActive]="'is-active'" class="nav-link">
              {{ 'link-faq' | translate }}
            </a>
          </li>
          <li class="nav-item d-block d-md-none" (click)="isCollapsed.set(!isCollapsed())">
            <a href="#" data-bs-target="#rules" data-bs-toggle="modal" [routerLinkActive]="'is-active'"
              class="nav-link">
              {{'link-rules' | translate}}
            </a>
          </li>
          <li class="nav-item d-block d-md-none" (click)="isCollapsed.set(!isCollapsed())">
            <a href="#" data-bs-target="#policy" data-bs-toggle="modal" [routerLinkActive]="'is-active'"
              class="nav-link">
              {{'link-policy' | translate}}
            </a>
          </li>
          <li class="nav-item d-block d-md-none" (click)="isCollapsed.set(!isCollapsed())">
            <a [routerLink]="currentLang() ? [currentLang(),'feedback'] : ['/feedback']" [routerLinkActive]="'is-active'"
              class="nav-link pb-3 pb-sm-2">
              {{'link-feedback' | translate}}
            </a>
          </li>
          <li class="nav-item ps-sm-5 d-none d-md-block">
            <img src="{{'local-reseller-logo' | translate}}" alt="" class="power-logo {{storedLanguage()}}">
          </li>
        </ul>
        <div class="language-selector">
          <div class="custom-select">
            <div class="selected-option">
              <img
                [src]="'https://assets.qnordicsgames.com/image/upload/t_media_lib_thumb/v1/SWEPOWERELX24/flags/' + storedLanguage() + '.svg'"
                alt="{{ selectedLanguage() }}" />
              <!-- <span>{{ storedLanguage.toUpperCase() }}</span> -->
            </div>
            <ul class="options">
              <li *ngFor="let lang of languageandBrands" (click)="onLanguageChange(lang.lang, lang.brand)">
                <img
                  [src]="'https://assets.qnordicsgames.com/image/upload/t_media_lib_thumb/v19/SWEPOWERELX24/flags/' + lang.lang + '.svg'"
                  alt="{{ lang.lang }}" />
                <span>{{ getLanguageName(lang.lang, lang.brand) }}</span>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </nav>
  </div>
</header>